import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/service-case", //服务案例
    name: "service-case",
    component: () => import("@/views/service-case/Index.vue"),
  },
  {
    path: "/service-case/detail/:id?", //案例详情
    name: "service-case-detail",
    component: () => import("@/views/service-case/Detail.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/service-case",
  component: Layout,
  children: router,
};

export default routerItem;
